import { render } from "./verify-radio.vue?vue&type=template&id=462aeb80&scoped=true"
import script from "./verify-radio.vue?vue&type=script&lang=js"
export * from "./verify-radio.vue?vue&type=script&lang=js"

import "./verify-radio.vue?vue&type=style&index=0&id=462aeb80&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462aeb80"]])

export default __exports__